module.exports = __webpack_public_path__ + "fonts/SUIT-Medium.112206a2.woff2";